import React from "react";
import "../../styles/TrustPages.css";

/* An explicitly illustrative quote mockup — a decorative visual
   (aria-hidden) shared by the homepage Quote Check promo and the
   contractor Trusted by Percy page. */

const LINES = [
  ["Indian Sandstone", "£1,450.00"],
  ["MOT & Sand", "£320.00"],
  ["Cement & Pointing", "£180.00"],
  ["Waste (Skip)", "£250.00"],
  ["Labour", "£1,600.00"],
];

const FairQuoteCard = () => (
  <div className="relative w-full max-w-[340px] mx-auto py-6" aria-hidden="true">
    <div className="relative w-full">
      <div className="tp-quote-shadow absolute inset-0 bg-white rounded-2xl border border-gray-200 rotate-[6deg] translate-x-4 translate-y-2 z-0"></div>

      <div className="tp-quote-card relative bg-white rounded-2xl shadow-[0_20px_40px_-12px_rgba(0,0,0,0.2)] border border-gray-100 p-5 sm:p-7 flex flex-col overflow-hidden rotate-[-2deg] z-10">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-20">
          <div className="tp-stamp border-4 border-green-500 text-green-500 font-black text-3xl uppercase tracking-widest px-5 py-2 rounded-xl bg-white/80 backdrop-blur-[2px] shadow-sm">
            EXAMPLE
          </div>
        </div>

        <div className="flex justify-between items-start border-b border-gray-100 pb-4 mb-5">
          <div>
            <h3 className="tp-quote-heading font-extrabold text-gray-900 text-lg uppercase tracking-widest">
              Quote
            </h3>
            <p className="text-[10px] sm:text-xs text-gray-400 mt-1 font-medium">
              Illustrative quote layout
              <br />
              Not an assessed customer quote
            </p>
          </div>
          <div className="tp-quote-logo w-10 h-10 bg-gray-50 rounded-xl flex items-center justify-center text-[9px] text-gray-400 font-bold border border-gray-100">
            LOGO
          </div>
        </div>

        <div className="flex-grow">
          <p className="text-[10px] sm:text-xs font-bold text-gray-400 mb-3 uppercase tracking-wider">
            Project: New Patio
          </p>
          <div className="space-y-3">
            {LINES.map(([item, price]) => (
              <div key={item} className="flex justify-between text-xs sm:text-sm">
                <span className="tp-quote-item text-gray-600 font-medium">{item}</span>
                <span className="tp-quote-price font-bold text-gray-900">{price}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t-2 border-gray-100 pt-4 mt-5 flex justify-between items-end">
          <span className="text-xs font-bold text-gray-400 uppercase tracking-wide">
            Total Estimate
          </span>
          <span className="tp-quote-total text-xl sm:text-2xl font-black text-gray-900">
            £3,800.00
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default FairQuoteCard;
